// 导入axios
import axios from 'axios'

const baseURL = process.env.VUE_APP_API_BASE_URL || 'https://lzls.zhieasy.cn'

const service = axios.create({
	baseURL,
	headers: {
		"Content-Type": "application/json"
		
	}
})
// console.log(localStorage.getItem('tokenuni'))

axios.defaults.baseURL = baseURL
axios.defaults.headers = {
	'Authorization': localStorage.getItem('tokenuni')
}
 // 请求拦截
service.interceptors.request.use(config => {
	let token = localStorage.getItem('token')
	// let token = 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJqdGkiOiIxNDg5OSIsInN1YiI6IjNlOTI0ZDUyIiwiaWF0IjoxNjkxNjYxMzUyLCJpc3MiOiJ6aGllYXN5IiwiZXhwIjoxNjkxNzQ3NzUyLCJ1c2VyIjoie1wiYWNjb3VudE5vbkV4cGlyZWRcIjpmYWxzZSxcImFjY291bnROb25Mb2NrZWRcIjpmYWxzZSxcImF1dGhJbmZvc1wiOltdLFwiY3JlYXRlVGltZVwiOjE2OTEzODA3NDQwMDAsXCJjcmVkZW50aWFsc05vbkV4cGlyZWRcIjpmYWxzZSxcImVuYWJsZWRcIjp0cnVlLFwiZXhhbVR5cGVcIjowLFwiaGVhZEltZ1VybFwiOlwiaHR0cDovL3Fpbml1c2F2ZS5sdW9zaGFvcWkuY24vbGFuZ2NlcnRoZWFkZXIuanBnXCIsXCJpZFwiOjE0ODk5LFwiaXNBZG1pblwiOjAsXCJpc0V4YW1cIjowLFwiaXNXZWxjb21lZFwiOjEsXCJuaWNrTmFtZVwiOlwiM2U5MjRkNTJcIixcIm9jY3VwYXRpb25cIjowLFwicGhvbmVOdW1cIjpcIjE1MzM5MjU5OTU2XCIsXCJzZXhcIjowLFwidXNlclN0YXR1c1wiOjEsXCJ1c2VybmFtZVwiOlwiM2U5MjRkNTJcIn0ifQ.DUbHyQ2chXwcpaNzuwF3fDd6hlzEiq90wgCa6pyG7wij1-MguSHrdh-R_fWOnB3MF39c-3ioUFqtnZ080jM8jQ'

	if (token) {

		// config.headers['token'] = token
		config.headers['token'] = token
	}
	return config
}, error => {
	return Promise.reject(error)
})

// 响应拦截
service.interceptors.response.use(response => {
	const res = response.data
	console.log(res)
	if (res.code !== 200) {
		// Message({
		// 	message: res.message || 'Error',
		// 	type: 'error',
		// 	duration: 3000
		// })
		if (res.code == 500) {
			// router.push('err500')
		} else if (res.code == 401) {
			localStorage.removeItem('token')
			// localStorage.removeItem('tokenuni')
			// router.replace('/')
		}
		if (res.code == 404) {
			// router.push('err404')
		}
		if (res.code == 30002 ) {
			localStorage.removeItem('token')
			// localStorage.removeItem('tokenuni')
			// router.replace('/')
		}
		if (res.code == 30003) {
			console.log('删掉token')
			// localStorage.removeItem('tokenuni')
			localStorage.removeItem('token')
			// router.replace('/')
		}

		return response
	} else {
		return response
	}
}, error => {
	if (error && error.response) {
		switch (error.response.status) {
			case 400:
				console.log('错误请求')
				break
			case 401:
				// localStorage.removeItem('token')
				// localStorage.removeItem('tokenuni')
				// // router.replace('/')
				console.log('token失效')
				break
			default:
				console.log('连接错误')
		}
	} else {
		console.log('连接服务器失败')
	}
	return Promise.reject(error)
})
/**
 * get post
 *
 */
export default class Http {
	static get(url, params) {
		return new Promise((resolve, reject) => {
			service.get(url, params).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err)
			})
		})
	}
	static post(url, data) {
		return new Promise((resolve, reject) => {
			service.post(url, data).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err)
			})
		})
	}
	static put(url, data) {
		return new Promise((resolve, reject) => {
			service.put(url, data).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err)
			})
		})
	}
}


